/* eslint-disable no-restricted-globals */
/* eslint-disable arrow-body-style */
/* eslint-disable max-len */
/* eslint-disable no-useless-escape */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-shadow */
import * as XLSX from 'xlsx-js-style';
import { DateTimeUtils } from './date-time.utils';
import { ICommentModel } from '../models/i-comment-modal';

const formatDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day}-${hours}-${minutes}-${seconds}`;
};

const getFileNameUSDA = (projectName: string, projectNumber: string, companyName: string): { fileName: string } => {
  const fileName = `${companyName} ${projectName} ${projectNumber}_USDA Weight`;
  return {
    fileName,
  };
};

type ColumnName = 'status' | 'sampleId' | 'sampleTypeMasterId' | 'depth' | 'weightReceived' | 'weightUsed' | 'weightRemaining';

const columnHeaders: Record<ColumnName, string> = {
  status: 'Status',
  sampleId: 'Sample ID',
  sampleTypeMasterId: 'Sample Type',
  depth: 'Depth',
  weightReceived: 'Weight Received (gm)',
  weightUsed: 'Weight Used (gm)',
  weightRemaining: 'Weight Remaining (gm)',
};

const customSheetNames: { [key: string]: string } = {
  asRecivedWorksheets: 'AS RECEIVED M C',
  moistureWorksheets: 'MOISTURE CONDITIONING SHEET',
  nativeSoilWorksheets: 'WORKSHEET',
  proctorWorksheets: 'PROCTOR WORKSHEET',
};

export class ExportTableUtil {
  static exportShipmentTableToExcel(
    data: any[],
    columns: ColumnName[],
    projectName: string,
    projectNumber: string,
    companyName: string,
  ) {
    const { fileName } = getFileNameUSDA(projectName, projectNumber, companyName);
    const rows: any[][] = [];
    // Add project details ( top of table update the custom details)
    rows.push(['Project Name:', projectName]);
    rows.push(['Company Name:', companyName]);
    rows.push(['Project Number:', projectNumber]);
    rows.push([]); // Empty row oru line spacing
    if (data.length > 0) {
      // rows.push(columns);
      rows.push(columns.map((column) => columnHeaders[column]));
      data.forEach((item) => {
        const rowData = columns.map((header) => item[header]);
        rows.push(rowData);
      });
    }
    const ws = XLSX.utils.aoa_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Shipment Received');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }

  static exportWorksheetTable(
    headerData: Record<string, any[]>,
    rowData: Record<string, any[]>,
    projectName: string,
    projectNumber: string,
    companyName: string,
    sampleReceivedDate?: string,
    instructionsConfirmedAt?: string,
    dueDate?: string,
    ovenDate?: string,
    wetTestData?: string,
    dryTestData?: string,
    geothermField?: boolean,
    rushTesting?: boolean,
    noteTest?: string,
    notesUpdatedBy?: string,
    customerName?: string,
    customerEmails?: string,
    customerContactNumber?: string,
    comments?: ICommentModel[],
    jobNumber?: string,
    projectLocation?: string,
    referenceId?: string
  ) {
    const formatDate = (date?: string, format = 'MM/dd/yyyy') =>
    date ? DateTimeUtils.getLocalDateTimeFromUTCDate(date, format).toString() : '';

    const formattedSampleReceivedDate = formatDate(sampleReceivedDate);
    const formattedInstructionsConfirmedAt = formatDate(instructionsConfirmedAt);
    const formattedDueDate = formatDate(dueDate);
    const formattedSampleReceivedDateForFileName = formatDate(sampleReceivedDate, 'MMddyy');

    const wsFileName = [companyName, projectName, projectNumber, formattedSampleReceivedDateForFileName]
      .filter(Boolean)
      .join('-');

    const workbook = XLSX.utils.book_new();
    const worksheetNames = Object.keys(headerData);

    worksheetNames.forEach((sheetName) => {
      const headers = headerData[sheetName];
      const rows = rowData[sheetName];

      if (!rows?.length) return;

      const worksheetData: any[][] = [];

      const leftData = [
        ['Project Name:', projectName],
        ['Project Reference:', referenceId],
        ['Project Number:', projectNumber],
        ['Project Location:', projectLocation],
        ['PO/Job Number:', jobNumber],
        ['Rushed:', rushTesting ? 'TRUE' : 'FALSE'],
        ['Company Name:', companyName],
        ['Customer Name:', customerName],
        ['Customer Email:', customerEmails],
        ['Customer Contact:', customerContactNumber],
        ['Geotherm Field Testing:', geothermField === true ? 'TRUE' : geothermField === false ? 'FALSE' : ''],
      ];
      worksheetData.push(...leftData);

      const headerRow = headers.map((h: { displayName: string; units: string }) =>
        h.units ? `${h.displayName} ${h.units}` : h.displayName
      );
      worksheetData.push(headerRow);

      rows.forEach((row) => {
        const rowDataArray = headers.map((h: { key: string }) => row[h.key]);
        worksheetData.push(rowDataArray);
      });

      const rightSide = [
        ['Sample Received:', formattedSampleReceivedDate],
        ['Instructions Confirmed At:', formattedInstructionsConfirmedAt],
        ['Due Date:', formattedDueDate],
        ['Oven Data:', ovenDate],
        ['Wet Test Data:', wetTestData],
        ['Dry Test Data:', dryTestData],
        ['Notes Updated:', notesUpdatedBy],
        ['Notes:', noteTest],
      ];

      rightSide.forEach(([label, value], i) => {
        worksheetData[i] ??= [];
        worksheetData[i][5] = label;
        worksheetData[i][6] = value;
      });

      comments?.forEach((comment, index) => {
        const rowIndex = index + rightSide.length;
        worksheetData[rowIndex] ??= [];
        worksheetData[rowIndex][5] = 'Bulk|Tube';
        worksheetData[rowIndex][6] = comment.projectComment || '';
      });

      const sheet = XLSX.utils.aoa_to_sheet(worksheetData);
      const sheetNameFinal = customSheetNames[sheetName] || sheetName;
      XLSX.utils.book_append_sheet(workbook, sheet, sheetNameFinal);
    });

    XLSX.writeFile(workbook, `${wsFileName}.xlsx`);
  }

  // New one-to-many Native Soil worksheet: one row per test result (built by the worksheet), with the same
  // project details block as exportWorksheetTable, a solid border under the last row of each sample and a dotted
  // border under the last row of each compaction effort, as on the worksheet
  static exportNativeSoilWorksheetTable(
    headerData: { key: string; displayName: string }[],
    rowData: any[],
    projectName: string,
    projectNumber: string,
    companyName: string,
    sampleReceivedDate?: string,
    instructionsConfirmedAt?: string,
    dueDate?: string,
    ovenDate?: string,
    wetTestData?: string,
    dryTestData?: string,
    geothermField?: boolean,
    rushTesting?: boolean,
    noteTest?: string,
    notesUpdatedBy?: string,
    customerName?: string,
    customerEmails?: string,
    customerContactNumber?: string,
    comments?: ICommentModel[],
    jobNumber?: string,
    projectLocation?: string,
    referenceId?: string
  ) {
    const formatDate = (date?: string, format = 'MM/dd/yyyy') =>
      date ? DateTimeUtils.getLocalDateTimeFromUTCDate(date, format).toString() : '';

    const wsFileName = [companyName, projectName, projectNumber, formatDate(sampleReceivedDate, 'MMddyy')]
      .filter(Boolean)
      .join('-');

    const worksheetData: any[][] = [
      ['Project Name:', projectName],
      ['Project Reference:', referenceId],
      ['Project Number:', projectNumber],
      ['Project Location:', projectLocation],
      ['PO/Job Number:', jobNumber],
      ['Rushed:', rushTesting ? 'TRUE' : 'FALSE'],
      ['Company Name:', companyName],
      ['Customer Name:', customerName],
      ['Customer Email:', customerEmails],
      ['Customer Contact:', customerContactNumber],
      ['Geotherm Field Testing:', geothermField === true ? 'TRUE' : geothermField === false ? 'FALSE' : ''],
    ];

    worksheetData.push(headerData.map((h) => h.displayName));

    // Sheet row index -> bottom border style
    const rowBorders = new Map<number, 'medium' | 'dotted'>();
    rowData.forEach((row, index) => {
      worksheetData.push(headerData.map((h) => row[h.key] ?? ''));
      if (row.lastRowOfSample && index < rowData.length - 1) {
        rowBorders.set(worksheetData.length - 1, 'medium');
      } else if (row.lastRowOfEffort) {
        rowBorders.set(worksheetData.length - 1, 'dotted');
      }
    });

    const rightSide = [
      ['Sample Received:', formatDate(sampleReceivedDate)],
      ['Instructions Confirmed At:', formatDate(instructionsConfirmedAt)],
      ['Due Date:', formatDate(dueDate)],
      ['Oven Data:', ovenDate],
      ['Wet Test Data:', wetTestData],
      ['Dry Test Data:', dryTestData],
      ['Notes Updated:', notesUpdatedBy],
      ['Notes:', noteTest],
    ];

    rightSide.forEach(([label, value], i) => {
      worksheetData[i][5] = label;
      worksheetData[i][6] = value;
    });

    comments?.forEach((comment, index) => {
      const rowIndex = index + rightSide.length;
      worksheetData[rowIndex] ??= [];
      worksheetData[rowIndex][5] = 'Bulk|Tube';
      worksheetData[rowIndex][6] = comment.projectComment || '';
    });

    const ws = XLSX.utils.aoa_to_sheet(worksheetData);

    rowBorders.forEach((style, rowIndex) => {
      for (let col = 0; col < headerData.length; col++) {
        const cellRef = XLSX.utils.encode_cell({ r: rowIndex, c: col });
        if (!ws[cellRef]) ws[cellRef] = { t: 's', v: '' };
        ws[cellRef].s = {
          border: { bottom: { style, color: { rgb: '8B8B8B' } } }
        };
      }
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, ws, customSheetNames['nativeSoilWorksheets']);
    XLSX.writeFile(workbook, `${wsFileName}.xlsx`);
  }

  static exportPrecastWorksheetTable(
  headerData: any[],
  rowData: any[],
  projectName: string,
  projectNumber: string,
  companyName: string,
  sampleReceivedDate?: string,
  instructionsConfirmedAt?: string,
  dueDate?: string,
  ovenDate?: string,
  wetTestData?: string,
  dryTestData?: string,
  geothermField?: boolean,
  rushTesting?: boolean,
  noteTest?: string,
  notesUpdatedBy?: string,
  customerName?: string,
  customerEmails?: string,
  customerContactNumber?: string,
  comments?: ICommentModel[],
  jobNumber?: string,
  projectLocation?: string,
  referenceId?: string
) {
    const blankColumnKeys: string[] = [
      'inHouseId',
      'castDate',
      'sampleId',
      'mixDesignCode',
      'sampleType',
      'mixId',
      'tare',
      'dryPlusTare',
      'drySoilWeight',
      'sampleDiameter',
      'sampleHeight',
      'volume',
      'dryTr',
      'density',
      'assignedTo',
      'status'
    ];

    const formatDate = (date?: string, format = 'MM/dd/yyyy') =>
      date ? DateTimeUtils.getLocalDateTimeFromUTCDate(date, format).toString() : '';

    const formattedSampleReceivedDate = formatDate(sampleReceivedDate);
    const formattedInstructionsConfirmedAt = formatDate(instructionsConfirmedAt);
    const formattedDueDate = formatDate(dueDate);
    const formattedSampleReceivedDateForFileName = formatDate(sampleReceivedDate, 'MMddyy');

    const wsFileName = [companyName, projectName, projectNumber, formattedSampleReceivedDateForFileName]
      .filter(Boolean)
      .join('-');

    const workbook = XLSX.utils.book_new();
    const worksheetData: any[][] = [];
    const separatorRowIndexes: number[] = [];

    // left side project info
    const projectFields = [
      ['Project Name:', projectName],
      ['Project Reference:', referenceId],
      ['Project Number:', projectNumber],
      ['Project Location:', projectLocation],
      ['PO/Job Number:', jobNumber],
      ['Rushed:', rushTesting ? 'TRUE' : 'FALSE'],
      ['Company Name:', companyName],
      ['Customer Name:', customerName],
      ['Customer Email:', customerEmails],
      ['Customer Contact:', customerContactNumber],
      ['Geotherm Field Testing:', geothermField === true ? 'TRUE' : geothermField === false ? 'FALSE' : ''],
    ];
    worksheetData.push(...projectFields);
    
    // header row
    const headerRow = headerData.map((h: { displayName: string; units: string }) =>
      h.units ? `${h.displayName} ${h.units}` : h.displayName
    );
    worksheetData.push(headerRow);

    const blankColumnIndexes: number[] = blankColumnKeys
      .map((key: string) => headerData.findIndex((h: { key: string }) => h.key === key))
      .filter((i: number) => i !== -1);

    // table rows
    let lastGroupId: string | null = null;

    rowData.forEach((row: any, index: number) => {
      const dataRow = headerData.map((h: { key: string }) => row[h.key]);
      if (lastGroupId === row.groupId) {
        blankColumnIndexes.forEach((colIndex: number) => {
          dataRow[colIndex] = '';
        });
      }

      worksheetData.push(dataRow);

      // Add bottom border only if next row exists AND preCastSampleId changes
      const nextRow = rowData[index + 1];
      if (nextRow && row.preCastSampleId !== nextRow.preCastSampleId) {
        separatorRowIndexes.push(worksheetData.length - 1); // current row index
      }

      lastGroupId = row.groupId;
    });

    // right side info
    const rightInfo = [
      ['Sample Received:', formattedSampleReceivedDate],
      ['Instructions Confirmed At:', formattedInstructionsConfirmedAt],
      ['Due Date:', formattedDueDate],
      ['Oven Data:', ovenDate],
      ['Wet Test Data:', wetTestData],
      ['Dry Test Data:', dryTestData],
      ['Notes Updated:', notesUpdatedBy],
      ['Notes:', noteTest]
    ];

    rightInfo.forEach(([label, value], index) => {
      worksheetData[index] ??= [];
      worksheetData[index][5] = label;
      worksheetData[index][6] = value;
    });

    const items = [
      { id: 1, type: 'Concrete' },
      { id: 2, type: 'FTB' },
      { id: 3, type: 'Grout/Slurry' },
      { id: 4, type: 'Other' }
    ];

    const typePriority = items.map(item => item.type);
    const sortedComments = [...(comments ?? [])].sort((a, b) => {
      const aIndex = typePriority.indexOf(a.sampleTypeName || '');
      const bIndex = typePriority.indexOf(b.sampleTypeName || '');
      const fallback = typePriority.length;
      return (aIndex === -1 ? fallback : aIndex) - (bIndex === -1 ? fallback : bIndex);
    });

    sortedComments.forEach((comment, index) => {
      const rowIndex = index + rightInfo.length;
      worksheetData[rowIndex] ??= [];
      worksheetData[rowIndex][5] = comment.sampleTypeName || '';
      worksheetData[rowIndex][6] = comment.projectComment || '';
    });

    const ws = XLSX.utils.aoa_to_sheet(worksheetData);

    // bottom border styles
    if (separatorRowIndexes.length > 0 && separatorRowIndexes[separatorRowIndexes.length - 1] === worksheetData.length - 1) {
      separatorRowIndexes.pop();
    }

    separatorRowIndexes.forEach((rowIndex: number) => {
      for (let col = 0; col < headerData.length; col++) {
        const cellRef = XLSX.utils.encode_cell({ r: rowIndex, c: col });
        if (!ws[cellRef]) ws[cellRef] = { t: 's', v: '' };
        ws[cellRef].s = {
          border: { bottom: { style: 'thin', color: { rgb: '000000' } } }
        };
      }
    });

    XLSX.utils.book_append_sheet(workbook, ws, 'Pre Cast Worksheet');
    XLSX.writeFile(workbook, `${wsFileName}.xlsx`);
  }

  // New one-to-many Precast worksheet: one row per test result (built by the worksheet), with the same project details
  // block as exportPrecastWorksheetTable and a solid border under the last row of each sample, as on the worksheet
  static exportPrecastTestResultWorksheetTable(
    headerData: { key: string; displayName: string }[],
    rowData: any[],
    projectName: string,
    projectNumber: string,
    companyName: string,
    sampleReceivedDate?: string,
    instructionsConfirmedAt?: string,
    dueDate?: string,
    ovenDate?: string,
    wetTestData?: string,
    dryTestData?: string,
    geothermField?: boolean,
    rushTesting?: boolean,
    noteTest?: string,
    notesUpdatedBy?: string,
    customerName?: string,
    customerEmails?: string,
    customerContactNumber?: string,
    comments?: ICommentModel[],
    jobNumber?: string,
    projectLocation?: string,
    referenceId?: string
  ) {
    const formatDate = (date?: string, format = 'MM/dd/yyyy') =>
      date ? DateTimeUtils.getLocalDateTimeFromUTCDate(date, format).toString() : '';

    const wsFileName = [companyName, projectName, projectNumber, formatDate(sampleReceivedDate, 'MMddyy')]
      .filter(Boolean)
      .join('-');

    const worksheetData: any[][] = [
      ['Project Name:', projectName],
      ['Project Reference:', referenceId],
      ['Project Number:', projectNumber],
      ['Project Location:', projectLocation],
      ['PO/Job Number:', jobNumber],
      ['Rushed:', rushTesting ? 'TRUE' : 'FALSE'],
      ['Company Name:', companyName],
      ['Customer Name:', customerName],
      ['Customer Email:', customerEmails],
      ['Customer Contact:', customerContactNumber],
      ['Geotherm Field Testing:', geothermField === true ? 'TRUE' : geothermField === false ? 'FALSE' : ''],
    ];

    worksheetData.push(headerData.map((h) => h.displayName));

    const separatorRowIndexes: number[] = [];
    rowData.forEach((row, index) => {
      worksheetData.push(headerData.map((h) => row[h.key] ?? ''));
      if (row.lastRowOfSample && index < rowData.length - 1) {
        separatorRowIndexes.push(worksheetData.length - 1);
      }
    });

    const rightInfo = [
      ['Sample Received:', formatDate(sampleReceivedDate)],
      ['Instructions Confirmed At:', formatDate(instructionsConfirmedAt)],
      ['Due Date:', formatDate(dueDate)],
      ['Oven Data:', ovenDate],
      ['Wet Test Data:', wetTestData],
      ['Dry Test Data:', dryTestData],
      ['Notes Updated:', notesUpdatedBy],
      ['Notes:', noteTest]
    ];

    rightInfo.forEach(([label, value], index) => {
      worksheetData[index][5] = label;
      worksheetData[index][6] = value;
    });

    // Same comment order as the precast preview: Concrete, FTB, Grout/Slurry, Other, then anything else
    const typePriority = ['Concrete', 'FTB', 'Grout/Slurry', 'Other'];
    const priority = (comment: ICommentModel) => {
      const i = typePriority.indexOf(comment.sampleTypeName || '');
      return i === -1 ? typePriority.length : i;
    };
    [...(comments ?? [])].sort((a, b) => priority(a) - priority(b)).forEach((comment, index) => {
      const rowIndex = index + rightInfo.length;
      worksheetData[rowIndex] ??= [];
      worksheetData[rowIndex][5] = comment.sampleTypeName || '';
      worksheetData[rowIndex][6] = comment.projectComment || '';
    });

    const ws = XLSX.utils.aoa_to_sheet(worksheetData);

    separatorRowIndexes.forEach((rowIndex) => {
      for (let col = 0; col < headerData.length; col++) {
        const cellRef = XLSX.utils.encode_cell({ r: rowIndex, c: col });
        if (!ws[cellRef]) ws[cellRef] = { t: 's', v: '' };
        ws[cellRef].s = {
          border: { bottom: { style: 'medium', color: { rgb: '8B8B8B' } } }
        };
      }
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, ws, 'Pre Cast Worksheet');
    XLSX.writeFile(workbook, `${wsFileName}.xlsx`);
  }
}
